import React, { useState } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import { Button } from 'reactstrap'
import { FormattedMessage, useIntl } from 'react-intl'

import styled from 'styled-components'
import { shade } from 'polished'

export function CallbackDeleteAlert({
  open,
  setOpen,
  warnTitle,
  warnMessage,
  successTitle,
  successMessage,
  errorTitle,
  errorMessage,
  callback,
  callbackParams,
  children,
}) {
  const [modal, setModal] = useState({
    confirmAlert: false,
    errorAlert: false,
  })
  const intl = useIntl()

  function handleCallback() {
    setOpen(false)
    callback(callbackParams)
      .then(() => {
        setModal({ confirmAlert: true })
      })
      .catch(e => {
        console.error(e)
        setModal({ errorAlert: false })
      })
  }

  return (
    <>
      <SweetAlert
        onConfirm={() => {}}
        title={intl.formatMessage({
          id: warnTitle,
        })}
        danger
        show={open}
        showCancel
        reverseButtons
        customButtons={
          <div>
            {children}
            <div className="d-flex justify-content-between">
              <ModalButton
                className="mr-1"
                $isConfirm={true}
                onClick={() => handleCallback()}
              >
                {intl.formatMessage({ id: 'Yes, delete!' })}
              </ModalButton>
              <ModalButton
                className="ml-1"
                $isConfirm={false}
                onClick={() => setOpen(false)}
              >
                {intl.formatMessage({ id: 'Cancel' })}
              </ModalButton>
            </div>
          </div>
        }
        focusCancelBtn={true}
      >
        <FormattedMessage id={warnMessage} />
      </SweetAlert>

      <SweetAlert
        onConfirm={() => {}}
        success
        title={intl.formatMessage({ id: successTitle })}
        confirmBtnBsStyle="success"
        show={modal.confirmAlert}
        customButtons={
          <div
            style={{
              width: '70%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <ConfirmationButton
              $isSuccess={true}
              onClick={() => setModal({ confirmAlert: false })}
            >
              {intl.formatMessage({ id: 'Ok' })}
            </ConfirmationButton>
          </div>
        }
      >
        <span className="sweet-alert-text">
          <FormattedMessage id={successMessage} />
        </span>
      </SweetAlert>

      <SweetAlert
        onConfirm={() => {}}
        error
        title={intl.formatMessage({ id: errorTitle })}
        confirmBtnBsStyle="success"
        show={modal.errorAlert}
        customButtons={
          <div
            style={{
              width: '70%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <ConfirmationButton
              $isSuccess={false}
              onClick={() => setModal({ errorAlert: false })}
            >
              {intl.formatMessage({ id: 'Ok' })}
            </ConfirmationButton>
          </div>
        }
      >
        <p className="sweet-alert-text">
          <FormattedMessage id={errorMessage} />
        </p>
      </SweetAlert>
    </>
  )
}

const ModalButton = styled(Button)`
  background-color: ${props =>
    props.$isConfirm ? '#ed5f5f' : '#fff'} !important;
  border: ${props =>
    props.$isConfirm ? '1px solid #ed5f5f' : '1px solid #979797'} !important;
  color: ${props => (props.$isConfirm ? '#fff' : '#979797')} !important;

  &:hover {
    background-color: ${props =>
      props.$isConfirm
        ? shade(0.2, '#ed5f5f')
        : shade(0.2, '#979797')} !important;
  }
`

const ConfirmationButton = styled(Button)`
  background-color: ${props =>
    props.$isSuccess ? '#28c76f' : '#ea5455'} !important;
  border-color: ${props =>
    props.$isSuccess ? '#28c76f' : '#ea5455'} !important;

  &:hover {
    background-color: ${props =>
      props.$isSuccess
        ? shade(0.2, '#28c76f')
        : shade(0.2, '#ea5455')} !important;
  }
`
